import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../AccountContext';
import { useGetAlternateMinimumDueArrangements } from '@app/sdk';
import { RequestAlternativeMinDueForm } from './RequestAlternativeMinDueForm';
import { UpdateAlternativeMinimumDueForm } from './UpdateAlternativeMinimumDueForm';
import { Segment } from 'semantic-ui-react';
import { ContentHeader, Table } from '@app/shared';
import { MasterDetailLayout } from '../../tms/components/MasterDetailLayout';
import { ColDef } from 'ag-grid-community';

export default function AlternateMinimumDueArrangements() {
  const { accountId } = useContext(AccountContext);
  const [alternateMinimumDues, setAlternateMinimumDues] = useState([]);
  const [editAlternateMinimumDue, setEditAlternateMinimumDue] = useState(undefined);

  const { data: alternateMinimumDue } = useGetAlternateMinimumDueArrangements(accountId);

  useEffect(() => {
    if (!alternateMinimumDue) {
      setAlternateMinimumDues([]);
      return;
    }
    const sortedAlternateMinimumDue = alternateMinimumDue
      .sort((a, b) => (a.arrangementTimestamp > b.arrangementTimestamp ? -1 : 1))
      .map((x) => ({ ...x, amount: x.amount.value }));
    setAlternateMinimumDues(sortedAlternateMinimumDue);
  }, [alternateMinimumDue]);

  const columnDefs: ColDef[] = [
    { field: 'arrangementId', headerName: 'Arrangement Id' },
    { field: 'status', headerName: 'Status' },
    { field: 'amount', headerName: 'Amount' },
    { field: 'startDate', headerName: 'Start Date' },
    { field: 'endDate', headerName: 'End Date' },
  ];

  const master = (
    <div style={{ height: '250px' }}>
      <ContentHeader>
        Arrangements
        <button className={'ui button'} onClick={() => setEditAlternateMinimumDue(null)}>
          New Arrangements
        </button>
      </ContentHeader>
      <Table
        items={alternateMinimumDues}
        columnDefs={columnDefs}
        onSelectItem={(data) => setEditAlternateMinimumDue(data)}
      />
    </div>
  );

  const detail = (
    <div>
      {editAlternateMinimumDue ? (
        <UpdateAlternativeMinimumDueForm
          key={JSON.stringify(editAlternateMinimumDue)}
          alternateMinimumDue={editAlternateMinimumDue}
        />
      ) : (
        <RequestAlternativeMinDueForm />
      )}
    </div>
  );

  return (
    <Segment>
      <h2>Alternate Minimum Dues Arrangements</h2>
      <Segment>
        <MasterDetailLayout master={master} detail={detail} height={'360px'} />
      </Segment>
    </Segment>
  );
}
